import axios from 'axios'

/**
 * Function to get token
 * @param {Object} payload
 * @return AxiosPromise
 */
export const getPosts = () => {
  return axios.get(`${process.env.API_URL}/articles?populate=*`)
}

/**
 * Function to get token
 * @param {Object} payload
 * @return AxiosPromise
 */
export const getPost = (slug) => {
  return axios.get(`${process.env.API_URL}/articles/?filters[slug][$eq]=${slug}&populate=*`)
}

